export default __webpack_public_path__ + "static/media/whyBlog.f5ec0f47.webp";